// ============================================
// components/GenderSelector.jsx
// ============================================
import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiX, FiCheck } from 'react-icons/fi';
import '../styles/Modals.scss';

const GENDER_OPTIONS = [
  { label: 'Male', value: 'male' },
  { label: 'Female', value: 'female' },
  { label: 'Non-binary', value: 'non-binary' },
  { label: 'Prefer not to say', value: 'prefer-not-to-say' },
  { label: 'Other', value: 'other' },
];

const GenderSelector = ({ currentValue, onSelect, onClose }) => {
  return (
    <AnimatePresence>
      <div className="modal-overlay" onClick={onClose}>
        <motion.div
          className="modal-content"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 50 }}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="modal-header">
            <h3>Select Gender</h3>
            <button className="close-button" onClick={onClose}>
              <FiX />
            </button>
          </div>

          <div className="options-list">
            {GENDER_OPTIONS.map((option) => (
              <button
                key={option.value}
                className={`option-item ${currentValue === option.value ? 'selected' : ''}`}
                onClick={() => onSelect(option.value)}
              >
                <span>{option.label}</span>
                {currentValue === option.value && (
                  <FiCheck className="selected-icon" />
                )}
              </button>
            ))}

            {currentValue && (
              <button
                className="option-item clear"
                onClick={() => onSelect('')}
              >
                <span>Clear Selection</span>
              </button>
            )}
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  );
};

export default GenderSelector;
